import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavbar from '../Navbar/Navbar';
import ProductionSidebar from '../../screens/ProductionManager/ProductionSidebar';

const ProductionManagerLayout = () => {

  return (
    <div>
    <header>
      <AdminNavbar />
    </header>
    <main>
      <ProductionSidebar />
      <Outlet mi />
    </main>
    <footer>
      {/* Add your admin footer here */}
    </footer>
  </div>
  );
};
 
export default ProductionManagerLayout;
